import { Link } from 'react-router-dom';

const exclusiveItems = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，酒店共度8小时细节全曝光',
    summary: '据知情人士透露，该男星近日在某五星级酒店与一名神秘女子共度长达8小时。监控画面显示两人举止亲密。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20scene%20of%20a%20luxury%20hotel%20corridor%20at%20night%2C%20mysterious%20atmosphere%2C%20silhouette%20of%20two%20people%2C%20warm%20dim%20lighting%2C%20noir%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20elegant%20composition%2C%20soft%20shadows%2C%20moody%20ambiance%2C%20cinematic%20lighting&width=800&height=600&seq=exclusive-article-01&orientation=landscape',
  },
  {
    id: 6,
    title: '某知名导演被曝长期潜规则新人演员，多位女星勇敢站出来指证',
    summary: '近日有多位女演员联合发声，指控某知名导演在选角过程中存在长期潜规则行为。以"试戏"为名要求演员单独前往酒店。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20dramatic%20scene%20of%20a%20director%20chair%20on%20an%20empty%20film%20set%2C%20spotlight%20casting%20long%20shadows%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20minimalist%20composition&width=800&height=600&seq=exclusive-article-06&orientation=landscape',
  },
  {
    id: 4,
    title: '揭秘：某热门电影票房造假内幕，午夜幽灵场上座率达100%',
    summary: '本报记者经过数月调查，发现某近期上映的热门影片存在严重的票房造假行为。多地午夜场"满座"但实际观影人数寥寥无几。',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20empty%20movie%20theater%20with%20red%20seats%20in%20darkness%2C%20single%20projector%20beam%20cutting%20through%2C%20eerie%20atmosphere%2C%20cinematic%20noir%20style%2C%20dark%20background%2C%20editorial%20photography%2C%20high%20contrast%2C%20moody%20ambiance&width=800&height=600&seq=exclusive-article-04&orientation=landscape',
  },
];

export default function ExclusiveGossip() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-3">
            独家八卦专区
          </h2>
          <p className="text-foreground-400 text-sm md:text-base max-w-md mx-auto">
            只有在这里才能看到的独家内幕爆料
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {exclusiveItems.map((article) => (
            <article key={article.id} className="group relative rounded-xl overflow-hidden h-72 md:h-80 border border-white/10 hover:border-primary-500/30 transition-all duration-300">
              <Link to={`/article/${article.id}`} className="block w-full h-full">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={`${article.title} - 51爆料网独家`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/20" />
                <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
                  <span className="px-3 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full mb-4 whitespace-nowrap">
                    独家爆料
                  </span>
                  <h3 className="text-foreground-50 font-heading font-bold text-lg md:text-xl leading-snug mb-3 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-foreground-300 text-sm line-clamp-2 leading-relaxed max-w-xs">
                    {article.summary}
                  </p>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}